"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("@scuf/common");

var _reactRouterDom = require("react-router-dom");

var _honeywellLogoRed = _interopRequireDefault(require("../../assets/honeywell-logo-red.svg"));

var _api = _interopRequireDefault(require("../common/api"));

var _util = _interopRequireDefault(require("../common/util"));

var _ApplicationContext = require("./ApplicationContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Page rendered to start reset/forgot password workflow, clicked into from login page
 */
var RequestPasswordReset = /*#__PURE__*/function (_Component) {
  _inherits(RequestPasswordReset, _Component);

  var _super = _createSuper(RequestPasswordReset);

  function RequestPasswordReset(props) {
    var _this;

    _classCallCheck(this, RequestPasswordReset);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var history, setNotification, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                history = _this.props.history;
                setNotification = _this.context.setNotification; // make fetch call to reset password

                _context.prev = 3;
                _context.next = 6;
                return _this.submit();

              case 6:
                result = _context.sent;
                setNotification(result, 'success', true);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                setNotification('Error requesting password reset', 'critical', true);

              case 13:
                history.push('/login');

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      var username = _this.state.username;
      return fetch("/user/auth/v1/resetPassword?email=".concat(username), {
        method: 'post',
        headers: {
          'content-type': 'application/json',
          // this header value is used as the host for the reset link sent in the email
          'origin-ui': _util["default"].getHostname()
        },
        body: JSON.stringify({})
      }).then(function (response) {
        return _api["default"].validateResponse(response);
      })["catch"](function (err) {
        console.error(err);
        throw err;
      });
    });

    _this.state = {
      username: '',
      redirect: false
    };
    return _this;
  }

  _createClass(RequestPasswordReset, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var redirect = this.state.redirect;

      if (redirect) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
          to: "/login"
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 3,
        mWidth: 3,
        sWidth: 2,
        xsWidth: 0
      }), /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 6,
        mWidth: 6,
        sWidth: 8,
        xsWidth: 12
      }, /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: this.handleSubmit,
        className: "reset-form"
      }, /*#__PURE__*/_react["default"].createElement(_common.Card, null, /*#__PURE__*/_react["default"].createElement(_common.Card.Header, {
        className: "reset-header"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: _honeywellLogoRed["default"],
        alt: "Honeywell Logo",
        className: "reset-logo"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "reset-title"
      }, "Reset Password Request")), /*#__PURE__*/_react["default"].createElement(_common.Card.Content, null, /*#__PURE__*/_react["default"].createElement(_common.Input, {
        fluid: true,
        label: "Username",
        placeholder: "name@email.com",
        onChange: function onChange(value) {
          return _this2.setState({
            username: value
          });
        },
        reserveSpace: true
      }), /*#__PURE__*/_react["default"].createElement(_common.Button, {
        type: "primary",
        content: "Submit",
        actionType: "submit"
      })), /*#__PURE__*/_react["default"].createElement(_common.Card.Footer, null, /*#__PURE__*/_react["default"].createElement(_common.Button, {
        type: "link",
        content: "Return to Login Page",
        onClick: function onClick() {
          _this2.setState({
            redirect: true
          });
        }
      }))))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 3,
        mWidth: 3,
        sWidth: 2,
        xsWidth: 0
      })));
    }
  }]);

  return RequestPasswordReset;
}(_react.Component);

RequestPasswordReset.contextType = _ApplicationContext.AppContext;
RequestPasswordReset.propTypes = {
  history: _propTypes["default"].shape({
    push: _propTypes["default"].func
  }).isRequired
};
var _default = RequestPasswordReset;
exports["default"] = _default;